export const translations = {
  en: {
    brand: "Stratedge UK",
    tagline: "International Consulting & Training",
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.services": "Services",
    "nav.training": "Training",
    "nav.experts": "Experts",
    "nav.insights": "Insights",
    "nav.videos": "Media Center",
    "nav.contact": "Contact",
    "nav.book": "Book a Consultation",
    "nav.join": "Join Expert Network",
    "nav.login": "Admin",
    "hero.eyebrow": "London · Serving Clients Worldwide",
    "hero.line1": "Precision Strategy.",
    "hero.line2": "World-Class",
    "hero.line3": "Executive Training.",
    "hero.sub": "Stratedge UK is an international consulting and training firm helping governments, institutions and ambitious companies navigate transformation, build leadership capability, and grow with confidence.",
    "hero.cta1": "Book a Consultation",
    "hero.cta2": "Explore Services",
    "hero.ctaDiagnostic": "Assess Your Business for Free",
    "hero.stat1": "Advisory & training engagements",
    "hero.stat2": "Countries & jurisdictions served",
    "hero.stat3": "Client satisfaction",
    "marquee.1": "Strategic Advisory",
    "marquee.2": "Digital Transformation",
    "marquee.3": "Artificial Intelligence",
    "marquee.4": "Executive Leadership",
    "marquee.5": "Institutional Consulting",
    "marquee.6": "Business Development",
    "intro.eyebrow": "Who We Are",
    "intro.title": "A British firm with a global mandate",
    "intro.body": "From our London base, Stratedge UK works with boards, ministries, and executive teams across Europe, the Middle East and beyond. We combine rigorous British professional standards with deep regional understanding — delivering consulting and training that is strategic, practical, and measurable.",
    "intro.point1": "Senior practitioners only — every engagement led by seasoned experts",
    "intro.point2": "Fully bilingual delivery in English and Arabic",
    "intro.point3": "Evidence-based methods tailored to your context",
    "services.eyebrow": "What We Do",
    "services.title": "Consulting & training across the full executive agenda",
    "services.sub": "Seven integrated practices, one standard of excellence.",
    "services.viewAll": "View all services",
    "s1.title": "Management Consulting",
    "s1.desc": "Strategy, operating models, performance improvement and transformation management for institutions and corporations.",
    "s2.title": "Training & Professional Development",
    "s2.desc": "Executive programmes, professional academies and bespoke corporate training, delivered in person and online.",
    "s3.title": "Digital Transformation",
    "s3.desc": "Digital strategy, service redesign, data and platform modernisation for government and enterprise.",
    "s4.title": "Artificial Intelligence",
    "s4.desc": "AI strategy, responsible AI governance, use-case portfolios and capability building for leaders.",
    "s5.title": "Business Development",
    "s5.desc": "Market entry, partnerships and commercial growth between the UK, Europe and the Middle East.",
    "s6.title": "Leadership & Management",
    "s6.desc": "Leadership assessment, executive coaching and board effectiveness programmes.",
    "s7.title": "Institutional & Corporate Consulting",
    "s7.desc": "Governance, institutional reform, restructuring and organisational excellence for public and private sectors.",
    "why.eyebrow": "Why Stratedge UK",
    "why.title": "The standard serious organisations choose",
    "why.1.title": "British Professional Standards",
    "why.1.desc": "London-based quality, rigour and confidentiality in every engagement.",
    "why.2.title": "Bilingual by Design",
    "why.2.desc": "Native-level English and Arabic consulting, training and materials.",
    "why.3.title": "Senior Experts Only",
    "why.3.desc": "A vetted network of practitioners with ministerial and board-level experience.",
    "why.4.title": "Measurable Outcomes",
    "why.4.desc": "Clear success metrics and transfer of capability — not just reports.",
    "expertise.eyebrow": "Areas of Expertise",
    "expertise.title": "Deep sector knowledge, applied internationally",
    "expertise.1": "Government & Public Sector",
    "expertise.2": "Banking & Financial Services",
    "expertise.3": "Energy & Utilities",
    "expertise.4": "Healthcare & Life Sciences",
    "expertise.5": "Education & Academies",
    "expertise.6": "Technology & Telecoms",
    "training.eyebrow": "Training Programmes",
    "training.title": "Executive education that changes practice",
    "training.sub": "Open-enrolment and bespoke programmes, in London, online and on-site worldwide.",
    "training.viewAll": "Browse all courses",
    "training.requestCta": "Request a Course",
    "training.register": "Register Now",
    "training.details": "Course details",
    "training.empty": "No courses match your filters yet.",
    "experts.eyebrow": "Expert Network",
    "experts.title": "A curated network of world-class consultants",
    "experts.sub": "Senior advisors, trainers and subject-matter experts — vetted, published and ready to deploy.",
    "experts.viewAll": "Meet our experts",
    "experts.joinCta": "Join Our Expert Network",
    "experts.joinSub": "Are you a senior consultant, trainer or academic? Apply to join the Stratedge UK network and work on international engagements.",
    "experts.searchPlaceholder": "Search by name...",
    "experts.filterCountry": "Country",
    "experts.filterSpecialization": "Specialization",
    "experts.filterDegree": "Academic degree",
    "experts.filterExpertise": "Area of expertise",
    "experts.filterExperience": "Min. years of experience",
    "experts.apply": "Apply filters",
    "experts.empty": "No experts match your filters yet.",
    "experts.years": "years of experience",
    "insights.eyebrow": "Insights",
    "insights.title": "Thinking from the front line of transformation",
    "insights.viewAll": "All insights",
    "insights.readMore": "Read article",
    "videos.eyebrow": "Media Center",
    "videos.title": "Talks, lectures & executive briefings",
    "videos.viewAll": "All videos",
    "cta.title": "Let's discuss your next move",
    "cta.sub": "Book a confidential consultation with a senior Stratedge UK advisor. We respond within one business day.",
    "cta.button": "Book a Consultation",
    "contact.email": "info@stratedgeuk.com",
    "contact.hq": "London, United Kingdom",
    "contact.title": "Contact Us",
    "contact.sub": "We would be delighted to hear from you. Reach out directly or send us a message.",
    "contact.formTitle": "Send us a message",
    "footer.tagline": "International consulting & training from London to the world.",
    "footer.explore": "Explore",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms & Conditions",
    "footer.rights": "All rights reserved.",
    "form.fullName": "Full Name",
    "form.email": "Email Address",
    "form.phone": "Phone Number",
    "form.whatsapp": "WhatsApp Number",
    "form.country": "Country",
    "form.city": "City",
    "form.organization": "Company / Organization",
    "form.jobTitle": "Job Title",
    "form.subject": "Subject",
    "form.message": "Message",
    "form.submit": "Submit",
    "form.sending": "Sending...",
    "form.success": "Thank you. Your submission has been received.",
    "form.error": "Submission failed. Please try again.",
    "form.required": "Required",
    "consult.title": "Book a Consultation",
    "consult.sub": "Tell us about your challenge and a senior advisor will contact you to arrange a confidential consultation.",
    "consult.interest": "Area of Interest",
    "consult.method": "Preferred Consultation Method",
    "consult.methodOnline": "Online (video call)",
    "consult.methodPhone": "Phone call",
    "consult.methodInPerson": "In person",
    "consult.date": "Preferred Date",
    "consult.submit": "Request Consultation",
    "consult.success": "Consultation request received. We will contact you within one business day.",
    "join.title": "Join Our Expert Network",
    "join.sub": "Stratedge UK welcomes applications from distinguished consultants, trainers and academics. Complete the application below; our team reviews every submission carefully and confidentially.",
    "join.section.personal": "Personal & Contact Information",
    "join.section.professional": "Current Position & Qualifications",
    "join.section.expertise": "Expertise & Experience",
    "join.section.availability": "Availability & Documents",
    "join.qualifications": "Academic Qualifications",
    "join.highestDegree": "Highest Academic Degree",
    "join.university": "University",
    "join.specialization": "Specialization",
    "join.yearsExperience": "Years of Experience",
    "join.expertiseAreas": "Areas of Expertise",
    "join.keySkills": "Key Skills",
    "join.languages": "Languages",
    "join.linkedin": "LinkedIn Profile",
    "join.scholar": "Google Scholar Profile (if available)",
    "join.orcid": "ORCID Profile (if available)",
    "join.trainingExp": "Training Experience",
    "join.consultingExp": "Consulting Experience",
    "join.sectorExp": "Industry / Sector Experience",
    "join.workRegions": "Countries / Regions Where You Can Work",
    "join.onlineAvail": "Available for Online Training",
    "join.onsiteAvail": "Available for On-site Training / Consulting",
    "join.cv": "CV / Resume (PDF or Word)",
    "join.photo": "Professional Photo (optional)",
    "join.bio": "Short Professional Biography",
    "join.notes": "Additional Notes",
    "join.consent": "I consent to the processing of my personal data in accordance with the Privacy Policy.",
    "join.submit": "Submit Application",
    "join.success": "Application submitted successfully. Our team will review it and contact you.",
    "join.commaHint": "Separate multiple entries with commas",
    "join.yes": "Yes",
    "join.no": "No",
    "join.currentJobTitle": "Current Job Title",
    "join.currentEmployer": "Current Employer",
    "reg.title": "Course Registration",
    "reg.preferredDate": "Preferred Course Date",
    "reg.delivery": "Preferred Delivery Method",
    "reg.participants": "Number of Participants",
    "reg.notes": "Additional Notes",
    "reg.submit": "Complete Registration",
    "reg.success": "Registration received. Please see the payment instructions below.",
    "reg.paymentTitle": "Payment Instructions",
    "course.duration": "Duration",
    "course.delivery": "Delivery",
    "course.language": "Language",
    "course.location": "Location",
    "course.fee": "Course Fee",
    "course.dates": "Dates",
    "course.schedule": "Schedule",
    "course.trainer": "Trainer",
    "course.seats": "Available Seats",
    "course.deadline": "Registration Deadline",
    "course.objectives": "Learning Objectives",
    "course.outline": "Course Outline",
    "course.outcomes": "Learning Outcomes",
    "course.audience": "Target Audience",
    "course.prerequisites": "Prerequisites",
    "course.back": "Back to all courses",
    "course.notFound": "Course not found.",
    "req.title": "Request a Training Course",
    "req.sub": "Can't find the course you need? Tell us the topic and we will design or source it for you.",
    "req.topic": "Requested Course Title / Topic",
    "req.objectives": "Training Objectives",
    "req.dates": "Preferred Dates",
    "req.sector": "Sector / Industry",
    "req.language": "Preferred Language",
    "req.submit": "Submit Request",
    "req.success": "Course request received. Our team will respond shortly.",
    "delivery.online": "Online",
    "delivery.in-person": "In-Person",
    "delivery.hybrid": "Hybrid",
    "delivery.on-site": "On-Site",
    "about.eyebrow": "About Stratedge UK",
    "about.title": "British rigour, international reach",
    "about.body1": "Stratedge UK is an international consulting and training company headquartered in London. We serve governments, institutions, corporations and professional leaders who demand rigorous thinking, senior attention and measurable results.",
    "about.body2": "Our work spans strategy and institutional reform, digital and AI transformation, leadership development and business growth. Every engagement is led by senior practitioners and supported by our vetted international expert network.",
    "about.vision.title": "Our Vision",
    "about.vision.body": "To be the trusted bridge between British professional excellence and the ambitions of institutions worldwide.",
    "about.mission.title": "Our Mission",
    "about.mission.body": "To deliver consulting and training that builds lasting capability — strategic, practical, bilingual and measurable.",
    "about.values.title": "Our Values",
    "about.values.body": "Integrity, excellence, confidentiality and partnership guide every engagement we accept.",
    "about.reach.title": "Global Reach",
    "about.reach.body": "From London we serve clients across the United Kingdom, Europe, the GCC, the wider Middle East and North Africa — on-site, online and hybrid.",
    "about.standards.title": "Standards & Quality",
    "about.standards.body": "Our methodologies follow recognised international standards in consulting, adult learning and programme management, adapted to each client's context and culture.",
    "page.servicesTitle": "Our Services",
    "page.servicesSub": "Integrated consulting and training practices for institutions that take performance seriously.",
    "page.trainingTitle": "Training Courses",
    "page.trainingSub": "Executive programmes and professional courses, delivered bilingually in London, online and on-site worldwide.",
    "page.expertsTitle": "Experts & Consultants",
    "page.expertsSub": "Meet the published members of the Stratedge UK expert network.",
    "page.insightsTitle": "Insights & Analysis",
    "page.insightsSub": "Perspectives on strategy, transformation, AI and leadership from our senior practitioners.",
    "page.videosTitle": "Videos & Media Center",
    "page.videosSub": "Selected talks, lectures and briefings from our network and learning library.",
    "filter.search": "Search",
    "filter.category": "Category",
    "filter.all": "All",
    "filter.delivery": "Delivery method",
    "legal.privacyTitle": "Privacy Policy",
    "legal.termsTitle": "Terms & Conditions",
    "legal.updated": "Last updated: July 2026",
    "notFound.title": "Page not found",
    "notFound.cta": "Return home",
    "common.featured": "Featured",
    "common.loading": "Loading...",
    "common.back": "Back",
    "common.readTime": "min read",
    "consult.free": "Free 30-minute consultation",
    "reg.amountDue": "Amount due",
    "reg.regId": "Registration ID",
    "reg.reference": "Transfer / payment reference",
    "reg.proof": "Upload proof of payment (optional)",
    "reg.paySubmit": "Submit Payment Details",
    "reg.payDone": "Payment details received. Your registration will be confirmed once the transfer is reviewed.",
    "book.title": "Book an Expert Consultation",
    "book.selectDate": "Choose a date",
    "book.selectTime": "Available times",
    "book.noSlots": "No available time slots on this date.",
    "book.noAvailability": "This expert has not published availability yet. Please use the general consultation form instead.",
    "book.duration": "Duration",
    "book.minutes": "min",
    "book.rate": "Hourly rate",
    "book.total": "Total amount due",
    "book.topic": "Consultation topic",
    "book.details": "Your details",
    "book.submit": "Confirm Booking",
    "book.success": "Booking received.",
    "book.pendingNote": "Your booking remains pending until payment is reviewed and confirmed by our team.",
    "book.payTitle": "Payment — Wise bank transfer",
    "book.id": "Booking ID",
    "join.consultType": "Consultation Type",
    "join.typeExpert": "Expert Consultation",
    "join.typeResearch": "Research Consultation",
    "join.typeBoth": "Both",
    "join.researchSection": "Research Profile",
    "join.researchAreas": "Research Areas",
    "join.discipline": "Academic Discipline",
    "join.methodologies": "Research Methodologies",
    "join.supervision": "Research Supervision Experience",
    "research.title": "Research Consultants",
    "research.sub": "University professors, academic researchers and research supervisors available for paid research consultations.",
    "research.filterArea": "Research area",
    "research.filterMethod": "Methodology",
    "research.tabExperts": "Experts & Consultants",
    "research.tabResearch": "Research Consultants",
    "book.type": "Consultation type",
    "book.stage": "Research stage",
    "book.support": "Type of support needed",
    "book.doc": "Research document (optional)",
    "book.portalNote": "A secure client portal account has been created for you — check your email for sign-in details to track this booking, files and meeting link.",
    "portal.client": "Client Portal",
    "course.closed": "Registration Closed",
    "course.completed": "Course Completed",
    "course.requestUpcoming": "Request This Course",
    "course.closedNote": "Registration for this course is closed. Request an upcoming session and we will notify you when it is scheduled.",
    "course.completedNote": "This course has already been delivered. Request an upcoming session and we will notify you.",
    "portal.expertTitle": "Expert Portal",
    "portal.expertSub": "Sign in with the credentials provided by Stratedge UK",
    "portal.clientTitle": "Client & Researcher Portal",
    "portal.clientSub": "Sign in with the credentials emailed to you after your first booking",
    "portal.signin": "Sign In",
    "portal.password": "Password",
    "portal.signingIn": "Signing in...",
    "portal.forgot": "Forgot password?",
    "portal.sendReset": "Send Reset Link",
    "portal.resetSent": "If this email is registered, a reset link has been sent to it.",
    "portal.resetTitle": "Set a new password",
    "portal.newPassword": "New password (min 8 characters)",
    "portal.resetDone": "Password updated. Sign in with your new password.",
    "portal.backToLogin": "Back to sign in",
    "portal.backToSite": "Back to website",
    "portal.support": "Need help? Contact",
    "book.docHint": "PDF, Word or image — max 10MB",
    "book.rsTitle": "Request Scheduling",
    "book.rsIntro": "This expert currently has no bookable time slots. Leave your details and the Stratedge UK team will coordinate a suitable appointment with the expert.",
    "book.rsPreferred": "Preferred days / times or notes",
    "book.rsSubmit": "Send Scheduling Request",
    "book.rsInstead": "No suitable time on this date? Send a scheduling request",
    "book.rsSuccess": "The selected expert is currently unavailable at a suitable time. Your request has been received successfully, and Stratedge UK will contact you to arrange a suitable appointment with the expert. You may also book a free 30-minute General Consultation with the Stratedge UK team.",
    "book.freeNote": "You can also book a free 30-minute General Consultation with the Stratedge UK team. This free consultation is not with the selected expert; it is with the Stratedge UK team.",
    "book.freeCta": "Book a Free 30-Minute Consultation with Stratedge UK",
    "consult.recommended": "Recommended",
  },
  ar: {
    brand: "ستراتيج المملكة المتحدة",
    tagline: "استشارات وتدريب دولي",
    "nav.home": "الرئيسية",
    "nav.about": "من نحن",
    "nav.services": "خدماتنا",
    "nav.training": "التدريب",
    "nav.experts": "الخبراء",
    "nav.insights": "الرؤى والمقالات",
    "nav.videos": "المركز الإعلامي",
    "nav.contact": "اتصل بنا",
    "nav.book": "احجز استشارة",
    "nav.join": "انضم إلى شبكة الخبراء",
    "nav.login": "الإدارة",
    "hero.eyebrow": "لندن · نخدم عملاءنا حول العالم",
    "hero.line1": "استراتيجية دقيقة.",
    "hero.line2": "تدريب تنفيذي",
    "hero.line3": "بمستوى عالمي.",
    "hero.sub": "ستراتيج المملكة المتحدة شركة استشارات وتدريب دولية تساعد الحكومات والمؤسسات والشركات الطموحة على قيادة التحول وبناء القدرات القيادية والنمو بثقة.",
    "hero.cta1": "احجز استشارة",
    "hero.cta2": "استكشف خدماتنا",
    "hero.ctaDiagnostic": "قيّم مؤسستك مجانًا",
    "hero.stat1": "مشروع استشاري وتدريبي",
    "hero.stat2": "دولة حول العالم نخدمها",
    "hero.stat3": "رضا العملاء",
    "marquee.1": "الاستشارات الاستراتيجية",
    "marquee.2": "التحول الرقمي",
    "marquee.3": "الذكاء الاصطناعي",
    "marquee.4": "القيادة التنفيذية",
    "marquee.5": "الاستشارات المؤسسية",
    "marquee.6": "تطوير الأعمال",
    "intro.eyebrow": "من نحن",
    "intro.title": "شركة بريطانية برسالة عالمية",
    "intro.body": "من مقرنا في لندن، نعمل مع مجالس الإدارة والوزارات والفرق التنفيذية في أوروبا والشرق الأوسط وخارجهما. نجمع بين المعايير المهنية البريطانية الرصينة والفهم العميق للمنطقة، لنقدم استشارات وتدريباً استراتيجياً وعملياً وقابلاً للقياس.",
    "intro.point1": "خبراء كبار فقط — كل مشروع يقوده مستشارون متمرسون",
    "intro.point2": "تقديم ثنائي اللغة بالكامل بالإنجليزية والعربية",
    "intro.point3": "منهجيات قائمة على الأدلة ومصممة لسياقكم",
    "services.eyebrow": "ماذا نقدم",
    "services.title": "استشارات وتدريب يغطيان كامل الأجندة التنفيذية",
    "services.sub": "سبع ممارسات متكاملة بمعيار واحد من التميز.",
    "services.viewAll": "عرض جميع الخدمات",
    "s1.title": "الاستشارات الإدارية",
    "s1.desc": "الاستراتيجية والنماذج التشغيلية وتحسين الأداء وإدارة التحول للمؤسسات والشركات.",
    "s2.title": "التدريب والتطوير المهني",
    "s2.desc": "برامج تنفيذية وأكاديميات مهنية وتدريب مؤسسي مصمم خصيصاً، حضورياً وعن بُعد.",
    "s3.title": "التحول الرقمي",
    "s3.desc": "الاستراتيجية الرقمية وإعادة تصميم الخدمات وتحديث البيانات والمنصات للحكومات والمؤسسات.",
    "s4.title": "الذكاء الاصطناعي",
    "s4.desc": "استراتيجية الذكاء الاصطناعي وحوكمته المسؤولة وبناء القدرات للقيادات.",
    "s5.title": "تطوير الأعمال",
    "s5.desc": "دخول الأسواق والشراكات والنمو التجاري بين المملكة المتحدة وأوروبا والشرق الأوسط.",
    "s6.title": "القيادة والإدارة",
    "s6.desc": "تقييم القيادات والإرشاد التنفيذي وبرامج فعالية مجالس الإدارة.",
    "s7.title": "الاستشارات المؤسسية والشركات",
    "s7.desc": "الحوكمة والإصلاح المؤسسي وإعادة الهيكلة والتميز التنظيمي للقطاعين العام والخاص.",
    "why.eyebrow": "لماذا ستراتيج",
    "why.title": "المعيار الذي تختاره المؤسسات الجادة",
    "why.1.title": "معايير مهنية بريطانية",
    "why.1.desc": "جودة وصرامة وسرية بمعايير لندن في كل مشروع.",
    "why.2.title": "ثنائي اللغة بالتصميم",
    "why.2.desc": "استشارات وتدريب ومواد بالإنجليزية والعربية بمستوى اللغة الأم.",
    "why.3.title": "خبراء كبار فقط",
    "why.3.desc": "شبكة مُدققة من الممارسين ذوي الخبرة الوزارية وعلى مستوى مجالس الإدارة.",
    "why.4.title": "نتائج قابلة للقياس",
    "why.4.desc": "مؤشرات نجاح واضحة ونقل للقدرات — لا مجرد تقارير.",
    "expertise.eyebrow": "مجالات الخبرة",
    "expertise.title": "معرفة قطاعية عميقة بتطبيق دولي",
    "expertise.1": "الحكومة والقطاع العام",
    "expertise.2": "المصارف والخدمات المالية",
    "expertise.3": "الطاقة والمرافق",
    "expertise.4": "الرعاية الصحية وعلوم الحياة",
    "expertise.5": "التعليم والأكاديميات",
    "expertise.6": "التقنية والاتصالات",
    "training.eyebrow": "البرامج التدريبية",
    "training.title": "تعليم تنفيذي يغير الممارسة",
    "training.sub": "برامج مفتوحة ومصممة خصيصاً في لندن وعن بُعد وفي مقرات عملائنا حول العالم.",
    "training.viewAll": "تصفح جميع الدورات",
    "training.requestCta": "اطلب دورة تدريبية",
    "training.register": "سجل الآن",
    "training.details": "تفاصيل الدورة",
    "training.empty": "لا توجد دورات مطابقة حالياً.",
    "experts.eyebrow": "شبكة الخبراء",
    "experts.title": "شبكة منتقاة من الاستشاريين العالميين",
    "experts.sub": "مستشارون ومدربون وخبراء كبار — مُدققون ومنشورون وجاهزون للعمل.",
    "experts.viewAll": "تعرف على خبرائنا",
    "experts.joinCta": "انضم إلى شبكة الخبراء",
    "experts.joinSub": "هل أنت استشاري أو مدرب أو أكاديمي بارز؟ تقدم بطلب الانضمام إلى شبكة ستراتيج واعمل على مشاريع دولية.",
    "experts.searchPlaceholder": "ابحث بالاسم...",
    "experts.filterCountry": "الدولة",
    "experts.filterSpecialization": "التخصص",
    "experts.filterDegree": "الدرجة العلمية",
    "experts.filterExpertise": "مجال الخبرة",
    "experts.filterExperience": "الحد الأدنى لسنوات الخبرة",
    "experts.apply": "تطبيق الفلاتر",
    "experts.empty": "لا يوجد خبراء مطابقون حالياً.",
    "experts.years": "سنة خبرة",
    "insights.eyebrow": "الرؤى",
    "insights.title": "أفكار من الخطوط الأمامية للتحول",
    "insights.viewAll": "جميع المقالات",
    "insights.readMore": "اقرأ المقال",
    "videos.eyebrow": "المركز الإعلامي",
    "videos.title": "محاضرات وإحاطات تنفيذية",
    "videos.viewAll": "جميع الفيديوهات",
    "cta.title": "لنناقش خطوتك القادمة",
    "cta.sub": "احجز استشارة سرية مع مستشار أول في ستراتيج. نرد خلال يوم عمل واحد.",
    "cta.button": "احجز استشارة",
    "contact.email": "info@stratedgeuk.com",
    "contact.hq": "لندن، المملكة المتحدة",
    "contact.title": "اتصل بنا",
    "contact.sub": "يسعدنا تواصلكم معنا. راسلونا مباشرة أو أرسلوا رسالتكم عبر النموذج.",
    "contact.formTitle": "أرسل لنا رسالة",
    "footer.tagline": "استشارات وتدريب دولي من لندن إلى العالم.",
    "footer.explore": "استكشف",
    "footer.company": "الشركة",
    "footer.legal": "قانوني",
    "footer.privacy": "سياسة الخصوصية",
    "footer.terms": "الشروط والأحكام",
    "footer.rights": "جميع الحقوق محفوظة.",
    "form.fullName": "الاسم الكامل",
    "form.email": "البريد الإلكتروني",
    "form.phone": "رقم الهاتف",
    "form.whatsapp": "رقم الواتساب",
    "form.country": "الدولة",
    "form.city": "المدينة",
    "form.organization": "الشركة / المنظمة",
    "form.jobTitle": "المسمى الوظيفي",
    "form.subject": "الموضوع",
    "form.message": "الرسالة",
    "form.submit": "إرسال",
    "form.sending": "جارٍ الإرسال...",
    "form.success": "شكراً لك. تم استلام طلبك.",
    "form.error": "فشل الإرسال. يرجى المحاولة مرة أخرى.",
    "form.required": "مطلوب",
    "consult.title": "احجز استشارة",
    "consult.sub": "أخبرنا عن التحدي الذي تواجهه وسيتواصل معك مستشار أول لترتيب استشارة سرية.",
    "consult.interest": "مجال الاهتمام",
    "consult.method": "طريقة الاستشارة المفضلة",
    "consult.methodOnline": "عن بُعد (مكالمة فيديو)",
    "consult.methodPhone": "مكالمة هاتفية",
    "consult.methodInPerson": "حضورياً",
    "consult.date": "التاريخ المفضل",
    "consult.submit": "طلب استشارة",
    "consult.success": "تم استلام طلب الاستشارة. سنتواصل معك خلال يوم عمل واحد.",
    "join.title": "انضم إلى شبكة الخبراء",
    "join.sub": "ترحب ستراتيج بطلبات الاستشاريين والمدربين والأكاديميين المتميزين. أكمل النموذج أدناه؛ يراجع فريقنا كل طلب بعناية وسرية تامة.",
    "join.section.personal": "المعلومات الشخصية وبيانات التواصل",
    "join.section.professional": "المنصب الحالي والمؤهلات",
    "join.section.expertise": "الخبرات والتخصصات",
    "join.section.availability": "التوفر والمستندات",
    "join.qualifications": "المؤهلات الأكاديمية",
    "join.highestDegree": "أعلى درجة علمية",
    "join.university": "الجامعة",
    "join.specialization": "التخصص",
    "join.yearsExperience": "سنوات الخبرة",
    "join.expertiseAreas": "مجالات الخبرة",
    "join.keySkills": "المهارات الرئيسية",
    "join.languages": "اللغات",
    "join.linkedin": "حساب لينكدإن",
    "join.scholar": "حساب جوجل سكولار (إن وجد)",
    "join.orcid": "حساب ORCID (إن وجد)",
    "join.trainingExp": "الخبرة التدريبية",
    "join.consultingExp": "الخبرة الاستشارية",
    "join.sectorExp": "الخبرة في القطاعات / الصناعات",
    "join.workRegions": "الدول / المناطق التي يمكنك العمل فيها",
    "join.onlineAvail": "متاح للتدريب عن بُعد",
    "join.onsiteAvail": "متاح للتدريب / الاستشارات في الموقع",
    "join.cv": "السيرة الذاتية (PDF أو Word)",
    "join.photo": "صورة مهنية (اختياري)",
    "join.bio": "نبذة مهنية مختصرة",
    "join.notes": "ملاحظات إضافية",
    "join.consent": "أوافق على معالجة بياناتي الشخصية وفقاً لسياسة الخصوصية.",
    "join.submit": "إرسال الطلب",
    "join.success": "تم إرسال طلبك بنجاح. سيراجعه فريقنا ويتواصل معك.",
    "join.commaHint": "افصل بين الإدخالات المتعددة بفواصل",
    "join.yes": "نعم",
    "join.no": "لا",
    "join.currentJobTitle": "المسمى الوظيفي الحالي",
    "join.currentEmployer": "جهة العمل الحالية",
    "reg.title": "التسجيل في الدورة",
    "reg.preferredDate": "تاريخ الدورة المفضل",
    "reg.delivery": "طريقة التقديم المفضلة",
    "reg.participants": "عدد المشاركين",
    "reg.notes": "ملاحظات إضافية",
    "reg.submit": "إتمام التسجيل",
    "reg.success": "تم استلام التسجيل. يرجى الاطلاع على تعليمات الدفع أدناه.",
    "reg.paymentTitle": "تعليمات الدفع",
    "course.duration": "المدة",
    "course.delivery": "طريقة التقديم",
    "course.language": "اللغة",
    "course.location": "الموقع",
    "course.fee": "رسوم الدورة",
    "course.dates": "التواريخ",
    "course.schedule": "الجدول",
    "course.trainer": "المدرب",
    "course.seats": "المقاعد المتاحة",
    "course.deadline": "آخر موعد للتسجيل",
    "course.objectives": "الأهداف التعليمية",
    "course.outline": "محاور الدورة",
    "course.outcomes": "المخرجات التعليمية",
    "course.audience": "الفئة المستهدفة",
    "course.prerequisites": "المتطلبات السابقة",
    "course.back": "العودة إلى جميع الدورات",
    "course.notFound": "الدورة غير موجودة.",
    "req.title": "اطلب دورة تدريبية",
    "req.sub": "لم تجد الدورة التي تحتاجها؟ أخبرنا بالموضوع وسنصممها أو نوفرها لك.",
    "req.topic": "عنوان / موضوع الدورة المطلوبة",
    "req.objectives": "أهداف التدريب",
    "req.dates": "التواريخ المفضلة",
    "req.sector": "القطاع / الصناعة",
    "req.language": "اللغة المفضلة",
    "req.submit": "إرسال الطلب",
    "req.success": "تم استلام طلب الدورة. سيرد فريقنا قريباً.",
    "delivery.online": "عن بُعد",
    "delivery.in-person": "حضوري",
    "delivery.hybrid": "هجين",
    "delivery.on-site": "في الموقع",
    "about.eyebrow": "عن ستراتيج",
    "about.title": "رصانة بريطانية وامتداد دولي",
    "about.body1": "ستراتيج المملكة المتحدة شركة استشارات وتدريب دولية مقرها لندن. نخدم الحكومات والمؤسسات والشركات والقيادات المهنية التي تتطلب تفكيراً رصيناً واهتماماً رفيع المستوى ونتائج قابلة للقياس.",
    "about.body2": "يمتد عملنا عبر الاستراتيجية والإصلاح المؤسسي والتحول الرقمي والذكاء الاصطناعي وتطوير القيادات ونمو الأعمال. كل مشروع يقوده ممارسون كبار وتدعمه شبكتنا الدولية المدققة من الخبراء.",
    "about.vision.title": "رؤيتنا",
    "about.vision.body": "أن نكون الجسر الموثوق بين التميز المهني البريطاني وطموحات المؤسسات حول العالم.",
    "about.mission.title": "رسالتنا",
    "about.mission.body": "تقديم استشارات وتدريب يبني قدرات دائمة — استراتيجية وعملية وثنائية اللغة وقابلة للقياس.",
    "about.values.title": "قيمنا",
    "about.values.body": "النزاهة والتميز والسرية والشراكة تقود كل مشروع نقبله.",
    "about.reach.title": "الامتداد العالمي",
    "about.reach.body": "من لندن نخدم عملاءنا في المملكة المتحدة وأوروبا ودول الخليج والشرق الأوسط وشمال أفريقيا — حضورياً وعن بُعد وبشكل هجين.",
    "about.standards.title": "المعايير والجودة",
    "about.standards.body": "تتبع منهجياتنا المعايير الدولية المعتمدة في الاستشارات والتعلم وإدارة البرامج، مع تكييفها لسياق وثقافة كل عميل.",
    "page.servicesTitle": "خدماتنا",
    "page.servicesSub": "ممارسات استشارية وتدريبية متكاملة للمؤسسات التي تأخذ الأداء على محمل الجد.",
    "page.trainingTitle": "الدورات التدريبية",
    "page.trainingSub": "برامج تنفيذية ودورات مهنية ثنائية اللغة في لندن وعن بُعد وفي الموقع حول العالم.",
    "page.expertsTitle": "الخبراء والاستشاريون",
    "page.expertsSub": "تعرف على الأعضاء المنشورين في شبكة خبراء ستراتيج.",
    "page.insightsTitle": "الرؤى والتحليلات",
    "page.insightsSub": "وجهات نظر في الاستراتيجية والتحول والذكاء الاصطناعي والقيادة من كبار ممارسينا.",
    "page.videosTitle": "الفيديوهات والمركز الإعلامي",
    "page.videosSub": "محاضرات وإحاطات مختارة من شبكتنا ومكتبتنا التعليمية.",
    "filter.search": "بحث",
    "filter.category": "التصنيف",
    "filter.all": "الكل",
    "filter.delivery": "طريقة التقديم",
    "legal.privacyTitle": "سياسة الخصوصية",
    "legal.termsTitle": "الشروط والأحكام",
    "legal.updated": "آخر تحديث: يوليو 2026",
    "notFound.title": "الصفحة غير موجودة",
    "notFound.cta": "العودة إلى الرئيسية",
    "common.featured": "مميز",
    "common.loading": "جارٍ التحميل...",
    "common.back": "رجوع",
    "common.readTime": "دقائق قراءة",
    "consult.free": "استشارة مجانية لمدة 30 دقيقة",
    "reg.amountDue": "المبلغ المستحق",
    "reg.regId": "رقم التسجيل",
    "reg.reference": "مرجع التحويل / الدفع",
    "reg.proof": "إرفاق إثبات الدفع (اختياري)",
    "reg.paySubmit": "إرسال بيانات الدفع",
    "reg.payDone": "تم استلام بيانات الدفع. سيتم تأكيد تسجيلك بعد مراجعة التحويل.",
    "book.title": "احجز استشارة مع الخبير",
    "book.selectDate": "اختر التاريخ",
    "book.selectTime": "الأوقات المتاحة",
    "book.noSlots": "لا توجد أوقات متاحة في هذا التاريخ.",
    "book.noAvailability": "لم ينشر هذا الخبير مواعيد متاحة بعد. يرجى استخدام نموذج الاستشارة العامة.",
    "book.duration": "المدة",
    "book.minutes": "دقيقة",
    "book.rate": "السعر بالساعة",
    "book.total": "إجمالي المبلغ المستحق",
    "book.topic": "موضوع الاستشارة",
    "book.details": "بياناتك",
    "book.submit": "تأكيد الحجز",
    "book.success": "تم استلام الحجز.",
    "book.pendingNote": "يبقى حجزك قيد الانتظار حتى تتم مراجعة الدفع وتأكيده من فريقنا.",
    "book.payTitle": "الدفع — تحويل بنكي عبر Wise",
    "book.id": "رقم الحجز",
    "join.consultType": "نوع الاستشارة",
    "join.typeExpert": "استشارة خبير",
    "join.typeResearch": "استشارة بحثية",
    "join.typeBoth": "كلاهما",
    "join.researchSection": "الملف البحثي",
    "join.researchAreas": "المجالات البحثية",
    "join.discipline": "التخصص الأكاديمي",
    "join.methodologies": "المنهجيات البحثية",
    "join.supervision": "خبرة الإشراف البحثي",
    "research.title": "المستشارون البحثيون",
    "research.sub": "أساتذة جامعات وباحثون أكاديميون ومشرفون بحثيون متاحون لاستشارات بحثية مدفوعة.",
    "research.filterArea": "المجال البحثي",
    "research.filterMethod": "المنهجية",
    "research.tabExperts": "الخبراء والاستشاريون",
    "research.tabResearch": "المستشارون البحثيون",
    "book.type": "نوع الاستشارة",
    "book.stage": "مرحلة البحث",
    "book.support": "نوع الدعم المطلوب",
    "book.doc": "مستند بحثي (اختياري)",
    "book.portalNote": "تم إنشاء حساب آمن لك في بوابة العميل — تحقق من بريدك الإلكتروني لبيانات الدخول لمتابعة حجزك وملفاتك ورابط الاجتماع.",
    "portal.client": "بوابة العميل",
    "course.closed": "التسجيل مغلق",
    "course.completed": "انتهت الدورة",
    "course.requestUpcoming": "اطلب هذه الدورة",
    "course.closedNote": "التسجيل في هذه الدورة مغلق. اطلب موعداً قادماً وسنعلمك عند جدولته.",
    "course.completedNote": "تم تقديم هذه الدورة بالفعل. اطلب موعداً قادماً وسنعلمك.",
    "portal.expertTitle": "بوابة الخبير",
    "portal.expertSub": "سجّل الدخول ببيانات الاعتماد المرسلة إليك من ستراتيج",
    "portal.clientTitle": "بوابة العميل والباحث",
    "portal.clientSub": "سجّل الدخول ببيانات الاعتماد المرسلة إلى بريدك بعد أول حجز",
    "portal.signin": "تسجيل الدخول",
    "portal.password": "كلمة المرور",
    "portal.signingIn": "جارٍ تسجيل الدخول...",
    "portal.forgot": "نسيت كلمة المرور؟",
    "portal.sendReset": "إرسال رابط إعادة التعيين",
    "portal.resetSent": "إذا كان هذا البريد مسجلاً لدينا، فقد أُرسل إليه رابط إعادة التعيين.",
    "portal.resetTitle": "تعيين كلمة مرور جديدة",
    "portal.newPassword": "كلمة المرور الجديدة (8 أحرف على الأقل)",
    "portal.resetDone": "تم تحديث كلمة المرور. سجّل الدخول بكلمة المرور الجديدة.",
    "portal.backToLogin": "العودة لتسجيل الدخول",
    "portal.backToSite": "العودة إلى الموقع",
    "portal.support": "تحتاج مساعدة؟ راسل",
    "book.docHint": "PDF أو Word أو صورة — بحد أقصى 10MB",
    "book.rsTitle": "طلب تنسيق موعد",
    "book.rsIntro": "لا تتوفر حاليًا أوقات حجز لهذا الخبير. اترك بياناتك وسيقوم فريق Stratedge UK بتنسيق موعد مناسب مع الخبير.",
    "book.rsPreferred": "الأيام / الأوقات المفضلة أو ملاحظات",
    "book.rsSubmit": "إرسال طلب التنسيق",
    "book.rsInstead": "لا يناسبك أي وقت في هذا التاريخ؟ أرسل طلب تنسيق موعد",
    "book.rsSuccess": "نظرًا لعدم توافر الخبير في الموعد المناسب حاليًا، تم استلام طلبك بنجاح. ستقوم شركة Stratedge UK بالتواصل معك لتنسيق موعد مناسب مع الخبير. كما يمكنك حجز استشارة عامة مجانية لمدة 30 دقيقة مع فريق Stratedge UK.",
    "book.freeNote": "يمكنك أيضًا حجز استشارة عامة مجانية لمدة 30 دقيقة مع فريق Stratedge UK. هذه الاستشارة ليست مع الخبير المحدد، وإنما مع فريق Stratedge UK.",
    "book.freeCta": "حجز استشارة مجانية لمدة 30 دقيقة مع فريق Stratedge UK",
    "consult.recommended": "موصى به",
  },
};
